module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter18"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch18"
    }
  }, [_vm._v("Caribbean Black Bean Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A soup with tropical influences that will warm you with its spicy flavors, serving black bean soup is also a terrific way to get your family to eat legumes. We like to serve this soup over steamed rice with cornbread on the side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Quick-soak method for beans: Dried beans are typically soaked overnight in cold water, but you can jump-start them by quick soaking. This method works well if you want to use any type of dried beans in your preparations. Cover dried beans with cold water in a large saucepan. Bring to a boil and cook, uncovered, over medium heat for 2 minutes. Remove from the heat, cover the pan, and let the beans soak for 1 hour. Drain the beans and use in any preparation. The beans may be kept refrigerated in an airtight container for up to 3 days. Freeze the cooked beans for up to 2 months.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 large white onions, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 jalapeño peppers, seeded and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ teaspoon ground allspice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cups presoaked black beans (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cups vegetable or chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in large skillet over medium-high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the onions, garlic, jalapeños, allspice, and cumin and sauté until the onion are softened.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5-to 7-quart slow cooker and add the beans, bay leaf, and broth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover the slow cooker and cook on high for 3 hours or on low for 6 hours. Season with salt and pepper. Remove the bay leaf before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serves 8–10")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v(" bean savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although I prefer to soak the beans overnight for this soup, you may substitute four 14- to 15-ounce cans black beans (drained and rinsed), and cook on low for 4 hours instead of the 6 called for.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695c1d97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/024-chapter18.vue
// module id = 126
// module chunks = 0